import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import ContinuousSlider from "./ContinuousSlider";
import DiscreteSlider from "./DiscreteSlider";
import RangeSlider from "./RangeSlider";
import InputSlider from "./InputSlider";
import CustomizedSlider from './CustomizedSlider'
import VerticalSlider from "./VerticalSlider";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    cardBody: {
        height: '100%'
    }
}));

function SliderComp() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Sliders</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Continuous sliders
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <ContinuousSlider />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Discrete sliders
                            </Typography>
                        </div>
                        <div className={classes.divContent} >
                            <DiscreteSlider style={{ padding: 5 }} />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Range slider
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <RangeSlider />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Slider with input field
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <InputSlider />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Slider with input field
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <CustomizedSlider />
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Vertical slider
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <VerticalSlider />
                        </div>
                    </Card>
                </Grid>

            </Grid>

        </div>

    )
}

export default SliderComp
